import { Validators, type ValidatorFn } from '@angular/forms';

export const noWhitespaceValidator: ValidatorFn = Validators.pattern(/\S/);
